module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/partner4-54ad1cada896b77b26778079e776d033.png";